import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { ArrowLeft, Storefront, QrCode, CheckCircle, MagnifyingGlass } from "@phosphor-icons/react";
import api from "@/lib/api";
import { initials } from "@/lib/format";
import { Input } from "@/components/ui/input";

export default function Discover() {
  const nav = useNavigate();
  const [list, setList] = useState(null);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/customer/participating").then((r) => setList(r.data)).catch(() => setList([]));
  }, []);

  if (!list) return <div className="pt-10 text-center text-muted-foreground">Loading…</div>;

  const filtered = list.filter(
    (b) =>
      b.name.toLowerCase().includes(q.toLowerCase()) ||
      (b.category || "").toLowerCase().includes(q.toLowerCase()) ||
      (b.city || "").toLowerCase().includes(q.toLowerCase())
  );

  return (
    <div className="pt-2 space-y-4">
      <button onClick={() => nav(-1)} data-testid="discover-back" className="text-muted-foreground flex items-center gap-1 text-sm">
        <ArrowLeft size={16} /> Back
      </button>
      <div>
        <h1 className="font-display font-bold text-2xl">Participating businesses</h1>
        <p className="text-sm text-muted-foreground">Where you can earn and redeem with OneKite. Show your QR at any of these to join.</p>
      </div>

      <div className="relative">
        <MagnifyingGlass size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <Input data-testid="discover-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search name, category or city…" className="pl-10 bg-muted/40 border-black/10 h-11 rounded-xl" />
      </div>

      <div className="space-y-3">
        {filtered.length === 0 && <p className="text-sm text-muted-foreground text-center py-6">No participating businesses found.</p>}
        {filtered.map((b, i) => (
          <div key={b.id} data-testid="discover-card" className="card-surface p-4 flex items-center gap-4 fade-up" style={{ animationDelay: `${i * 40}ms` }}>
            <div className="h-12 w-12 rounded-xl bg-primary/15 flex items-center justify-center overflow-hidden shrink-0">
              {b.logo ? <img src={b.logo} alt="" className="h-full w-full object-cover" /> : <span className="font-display font-bold text-primary">{initials(b.name)}</span>}
            </div>
            <div className="flex-1 min-w-0">
              <p className="font-semibold truncate">{b.name}</p>
              <p className="text-xs text-muted-foreground truncate">{b.category}{b.city ? ` · ${b.city}` : ""}</p>
            </div>
            {b.joined ? (
              <span className="flex items-center gap-1 text-xs text-primary font-medium"><CheckCircle size={16} weight="fill" /> Joined</span>
            ) : (
              <Link to="/app/qr" data-testid="discover-showqr" className="flex items-center gap-1 text-xs text-muted-foreground hover:text-primary">
                <QrCode size={16} /> Show QR
              </Link>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
